<template>
  <div class>
    <h5 class="info-head">专业类别<span v-if="!basicIsShow" style="margin-left:12px;color:red;font-weight:normal;">(存在入库审批中的专业类别,无法修改)</span>
      <el-button v-if="basicIsShow" icon="el-icon-plus" @click="add">新增</el-button>
      <el-button style="margin-right: 30px;" v-if="basicIsShow&&!isPreAudit" @click="deleteSpsList">批量删除</el-button>
    </h5>

    <el-table :data="spss" border strip @selection-change="handleSelectionChange">
        <el-table-column header-align="center" align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column header-align="center" align="center" type="index" width="100" label="序号"></el-table-column>
        <el-table-column header-align="center" align="center"
            prop="fpersonname"
            label="专业负责人">
        </el-table-column>
        <el-table-column header-align="center" align="center"
            prop="servicename"
            label="产品及服务">
        </el-table-column>
        <el-table-column header-align="center" align="center" label="服务区域">
            <template slot-scope="scope">
                {{scope.row.provinceName}}-{{scope.row.cityName}}
            </template>
        </el-table-column>
        <el-table-column header-align="center" align="center"
            prop="status"
            label="认证状态">
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作" v-if="basicIsShow&&!isPreAudit">
            <template slot-scope="scope">
                <a @click.prevent="remove(scope.row)" class="delete-btn" v-if="scope.row.canDoFlag&&scope.row.supplierBigStatus=='0'">删除</a>
            </template>
        </el-table-column>       
    </el-table>

    <!-- <div class="splitter"></div>
    <div class="text-center">
      <el-button :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
    </div> -->
    <el-dialog :title="isNaN(editIndex)?'新增专业类别':'编辑专业类别'" :visible.sync="categoryFormVisible">
      <el-form
        :model="category"
        label-width="150px"
        :rules="rules"
        ref="categoryForm"
        class="supplier-form"
      >
        <el-form-item label="专业负责人：" prop="cfcellpeopleid">
          <el-select v-model="category.cfcellpeopleid" placeholder="请选择" style="float:left">
            <el-option
              v-for="item in linkstosps"
              :key="item.id"
              :label="item.fpersonname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品及服务：" prop="cfservicetypeid">
          <el-cascader
            @change="selectServiceType"
            ref="serviceTyper"
            v-model="serviceType"
            placeholder="输入搜索"
            expand-trigger="hover"
            :options="productTypes"
            filterable
            :change-on-select="false"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="服务区域：" prop="provinceArr">
          <el-select
            multiple
            collapse-tags
            @change="selectProvince"
            v-model="category.provinceArr"
            placeholder="请选择省份"
            style="float:left"
            filterable class="multipleSel"
          >
            <el-option
              v-for="item in provinces"
              :key="item.fid"
              :label="item.fnameL2"
              :value="item.fid"
            ></el-option>
          </el-select>
          <el-select
            multiple
            collapse-tags
            v-model="category.cityArr"
            placeholder="请选择城市"
            style="float:left;margin-left: 10px;"
          >
            <el-option
              v-for="item in cityList"
              :key="item.fid"
              :label="item.fnameL2"
              :value="item.fid"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="categoryFormVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="confirmBFlag" @click="submitCategory">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  SELECT_PROVINCE,
  ADD_SPSS,
  ADD_CATEGORY,
  EDIT_CATEGORY,
  REMOVE_CATEGORY
} from "@/store/mutation-types";
import { spssRules } from "@/util/rules";
import _ from "lodash/core";
import apis from '@/store/apis'

export default {
  name: "supplier-spss",
  data() {
    return {
        rules: spssRules,
        category: {
            fpersonname: "", //实际挂靠人
            cfcellpeopleid: "", //挂靠人id
            cfservicetypeid: "", //产品及服务id
            provinceArr: [],
            cityArr: [],
            servicename: "",
            cfremak: ""
        },
        categoryFormVisible: false,
        serviceType: [],
        cityList: [],
        province_city:{},
        editIndex: void 0,
        isPreAudit: false,
        isSubmit: false,
        notDelMap: {
            3: '入库审批中',
            5: '引入审批中',
            7: '已认证转待认证审批中',
            9: ' 已认证转禁用审批中',
            11: ' 已认证转停用审批中',
            13: ' 已认证转冻结审批中',
            15: ' 已认证转战略审批中',
            17: ' 战略转禁用审批中',
            19: ' 战略转停用审批中',
            21: ' 战略转冻结审批中',
            23: ' 冻结转认证审批中',
            31: ' 战略转待认证审批中'
        },
        selectedSpss: [],
        confirmBFlag: false,
        basicIsShow: false  // 判断信息是否修改
    };
  },
  computed: mapGetters([
    "spss",
    "linkstosps",
    "productTypes",
    "provinces",
    "cities"
  ]),
  watch: {},
  methods: {
    //省份选择回调
    selectProvince(val) {
      //重置城市选项
      this.cityList = [];
      val.forEach(item => {
        Promise.all([this.setPid(item), this.getCities()])
          .then(r => {
            if(!this.province_city[item]) this.province_city[item]= this.cities.map(val=>{
                return val.fid;
            });  //存储城市省份关联关系
            this.cityList = this.cityList.concat(this.cities);
            this.$root.loading = false;
          })
          .catch(err => (this.$root.loading = false));
      });
      this.$nextTick(() => {
        //重置已选城市
        let cityArr = [];
        this.category.cityArr.forEach(row => {
          let cityObj = this.cityList.find(value => {
            return value.fid == row;
          });
          if (cityObj) {
            cityArr.push(row);
          }
        });
        this.category.cityArr = cityArr;
      });
    },
    ...mapActions([
      "getSpss",
      "getLinksToSps",
      "getProductTypes",
      "submitSpss",
      "getProvinces",
      "getCities"
    ]),
    ...mapMutations({
      addCategory: ADD_CATEGORY,
      editCategory: EDIT_CATEGORY,
      delCategory: REMOVE_CATEGORY,
      setPid: SELECT_PROVINCE
    }),
    add() {
      this.editIndex = void 0;
      this.category = {
        fpersonname: "",
        cfcellpeopleid: "",
        cfservicetypeid: "",
        provinceArr: [],
        cityArr: [],
        servicename: "",
        cfremak: ""
      };
      this.serviceType = [];
      this.cityList = [];
      this.categoryFormVisible = true;
      this.confirmBFlag = false
      this.$nextTick(() => {
        //一定要在此处reset，否则this.category会被刷掉
        this.$refs.categoryForm.resetFields();
      });
    },
    edit(i) {
      this.editIndex = i;
      this.category = Object.assign({}, this.spss[i]);
      this.$nextTick(() => {
        this.serviceType = this.category.farParent.split(",");
        this.categoryFormVisible = true;
      });
    },
    remove(obj) {
      let desc = this.notDelMap[obj.cfdisablestate]
      if (desc) {
        this.$alert('该条数据处于' + desc + '，不可删除，请等待审批结束后操作!')
      } else {
        if (this.spss.length == 1) {
          this.$message({type: "error", message: "请勿全部删除所有专业类别，需要保留一个！"});
          return
        }

        this.$confirm("此操作将删除该条记录, 请慎重选择, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let param = [obj.id]
          this.deleteMethod(param)
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      }
    },
    deleteSpsList () {
      /*
       * 1.检查选中的数据是不是有审批中的
       * 2.调用接口删除
      */
      let checkFlag = false
      let delSpsIdList = []
      this.selectedSpss.forEach(item => {
          let desc = this.notDelMap[item.cfdisablestate]
          if (desc) {
              checkFlag = true
              this.$message({type:'error',message: '选中删除的专业类别存在审批中的，请将其去除勾选后提交'})
              return
          } else {
              delSpsIdList.push(item.id)
          }
      })
      if (checkFlag) {
          return
      }

      // 必须保留一个专业类别
      if (this.selectedSpss.length == this.spss.length) {
        this.$message({type: "error", message: "请勿全部删除所有专业类别，需要保留一个！"});
        return
      }

     this.$confirm("此操作将这些记录, 请慎重选择, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.deleteMethod(delSpsIdList)
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    deleteMethod (spsIdList) {
      let param = {
        stockId: this.$root.stockId,
        idList: spsIdList
      }
      this.$http.post('rest/api/checkUserInfo/deleteSps', param).then(res => {
        if (res.data.result) {
          this.$message({type:'success',message: '删除成功'})
          this.getSpss()
        } else {
          this.$message({type:'error',message: res.data.message})
        }
      })
    },
    selectServiceType(types) {
        this.$nextTick(()=>{
            let typer = this.$refs.serviceTyper;
            this.category.cfservicetypeid = typer.getCheckedNodes()[0].value;
            this.category.servicename = typer.getCheckedNodes()[0].label;
            this.category.farParent = typer.getCheckedNodes()[0].path.join(",");
        })
    },
    resetServiceList(){
        let list = [], names = [];
        //遍历所选城市
        this.category.cityArr.forEach(city=>{
            for(let province in this.province_city){
                if(this.province_city[province].indexOf(city) != -1){
                    list.push({
                        cfprovinceid: province,
                        cfcityid: city
                    })
                }
            }
        })
        let pArr = list.map(pId=>{
            return pId.cfprovinceid;
        })
        this.category.provinceArr.forEach(province=>{
            if(pArr.indexOf(province) == -1){
                    list.push({
                        cfprovinceid: province,
                        cfcityid: ''
                    })
            }
        })
        list.forEach(obj=>{
            let pObj = this.provinces.find(val=>{
                return obj.cfprovinceid == val.fid;
            })
            let cObj = this.cityList.find(val=>{
                return obj.cfcityid == val.fid;
            })
            if(cObj){
                names.push(pObj.fnameL2+'-'+cObj.fnameL2);
            }else{
                names.push(pObj.fnameL2);
            }
            
        })
        this.category['serviceaList'] = list;
        this.category['names'] = names;
    },
    submitCategory() {

      this.$refs.categoryForm.validate(valid => {
        if (valid) {
          this.resetServiceList();
          this.category.fpersonname = _.find(this.linkstosps, {
            id: this.category.cfcellpeopleid
          }).fpersonname;

          // 开始调用后台接口
          let addParam = {
						stockId: this.$root.stockId,
            spss: [
              {
                cfservicetypeid: this.category.cfservicetypeid,
                cfcellpeopleid: this.category.cfcellpeopleid,
                fpersonname: this.category.fpersonname,
                serviceaList: this.category.serviceaList
              }
            ]
          }
          this.confirmBFlag = true
					this.$http.post('rest/api/checkUserInfo/addSpss', addParam).then(res => {
            
						if (res.data.result) {
              this.getSpss()
							this.categoryFormVisible = false
						} else {
							this.$message({type: 'error', message: res.data.message})
            }
					})
        } else {
          console.log("error submit!!");
        }
      });
    },
    submit() {
      this.isSubmit = true;
      this.submitSpss().then(
        res => {
          if (res.data.result) {
            this.$confirm(res.data.message || "操作成功！", "", {
              confirmButtonText: "确定",
              showCancelButton: false,
              showClose: false,
              type: "success",
              center: true
            }).then(
              () => {
                this.isSubmit = false;
                window.location.reload();
              },
              () => {
                this.isSubmit = false;
                window.location.reload();
              }
            );
            window.sessionStorage.setItem(this.$route.name, "saved");
          } else {
            this.isSubmit = false;
            this.$alert(res.data.message);
          }
        },
        err => {
          this.isSubmit = false;
          this.$alert(err);
        }
      );
    },
    handleSelectionChange(val) {
      this.selectedSpss = val
    },
    checkStatus(){
      return apis.getLittleStatus(this.$root.stockId,this.hasLittleStatus012,this.hasLittleStatus3)
    }
  },
  created() {
    this.$root.loading = true;
    Promise.all([
      this.getSpss(),
      this.getLinksToSps(),
      this.getProductTypes(),
      this.getProvinces()
    ]).then(r => (
        this.$nextTick(function(){
            this.$root.loading = false
        })
    )).catch(err => (this.$root.loading = false));
  },
  mounted() {
    this.isPreAudit = window.sessionStorage.getItem("isPreAudit") == 1;
    this.basicIsShow = window.sessionStorage.getItem('basicIsShow')=='true'?true:false
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only --> 
<style scoped>
    .multipleSel .el-select__input{
        width: 40px !important;
        max-width: 100px !important;
        margin: 0 !important;
        border: 0 !important;
        background: none !important;
        outline: 0 !important;
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Spss.vue